import { render, staticRenderFns } from "./BroadcastEquipmentInfo.vue?vue&type=template&id=21a7e09c&scoped=true"
import script from "./BroadcastEquipmentInfo.vue?vue&type=script&lang=js"
export * from "./BroadcastEquipmentInfo.vue?vue&type=script&lang=js"
import style0 from "./BroadcastEquipmentInfo.vue?vue&type=style&index=0&id=21a7e09c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a7e09c",
  null
  
)

export default component.exports